import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import { ClientType } from '../types'

export const HOME = 'HOME'

export const ANALYTICS = 'ANALYTICS'

export const DASHBOARDS = 'DASHBOARDS'

export const PINNED = 'PINNED'

export const CALLS = 'CALLS'

export const CONTACTS = 'CONTACTS'

export const PIPELINES = 'PIPELINES'

export const TEMPLATES = 'TEMPLATES'

export const STAGE_BOARDS = 'STAGE_BOARDS'

export const SMART_BOARDS = 'SMART_BOARDS'

export const NOTIFICATIONS = 'NOTIFICATIONS'

export const ANALYTICS_CO_PILOT = 'ANALYTICS_CO_PILOT'

export const GIS = 'GIS'

export const adminApplicationNavItems = {
   profileSettings: 'PROFILE_SETTINGS',
   billing: 'BILLING',
   integrations: 'INTEGRATIONS',
   parameterStore: 'PARAMETER_STORE',
   portals: 'PORTALS'
}

export const adminUserSectionNavItems = {
   usersAnsPermissions: 'USERS_AND_PERMISSIONS',
   ROLES: 'ROLES',
   USERS: 'USERS',
   GROUPS: 'GROUPS',
   PROPERTIES: 'PROPERTIES',
   UPLOAD_USERS: 'UPLOAD_USERS',
   EXPORT_USERS: 'EXPORT_USERS',
   CLOCK_IN_CONFIG: 'CLOCK_IN_CONFIG'
}

export const adminContactSectionNavItems = {
   contactSettings: 'CONTACT_SETTINGS',
   contactFields: 'CONTACT_FIELDS',
   contactLogs: 'CONTACT_LOGS',
   uploadContacts: 'UPLOAD_CONTACTS',
   exportContacts: 'EXPORT_CONTACTS',
   configurations: 'CONFIGURATIONS'
}

export const adminPipelinesSectionNavItems = {
   analyticsBuilder: 'ANALYTICS_BUILDER',
   pipelineSettings: 'PIPELINE_SETTINGS',
   boards: 'BOARDS',
   recordTemplate: 'RECORD_TEMPLATE',
   leadTemplate: 'LEAD_TEMPLATE',
   uploadPipelineItems: 'UPLOAD_PIPELINE_ITEMS',
   exportLeads: 'EXPORT_LEADS',
   dealTemplate: 'DEAL_TEMPLATE',
   uploadDeals: 'UPLOAD_DEALS',
   exportDeals: 'EXPORT_DEALS',
   activities: 'ACTIVITIES',
   activityTemplates: 'ACTIVITY_TEMPLATES',
   uploadActivities: 'UPLOAD_ACTIVITIES',
   activityLogs: 'ACTIVITY_LOGS',
   taskTemplates: 'TASK_TEMPLATES',
   sharableResources: 'SHARABLE_RESOURCES',
   downloads: 'DOWNLOADS',
   pipelinePermissions: 'PIPELINE_PERMISSIONS',
   leadDistribution: 'LEAD_DISTRIBUTION',
   distributionRules: 'DISTRIBUTION_RULES',
   agentAllocationGroups: 'AGENT_ALLOCATION_GROUPS',
   distributionLogs: 'DISTRIBUTION_LOGS',
   workflows: 'WORKFLOWS',
   allWorkflows: 'ALL_WORKFLOWS',
   workflowLogs: 'WORKFLOW_LOGS',
   relations: 'RELATIONS',
   pipelineEvents: 'PIPELINE_EVENTS',
   documentTemplates: 'DOCUMENT_TEMPLATES',
   scoringConfig: 'SCORING_CONFIG',
   scoringRules: 'SCORING_RULES',
   scoringReCalculationLogs: 'SCORING_RECALCULATION_LOGS',
   dataLoading: 'DATA_LOADING'
}

export const adminTemplatesSectionNavItems = {
   analyticsBuilder: 'ANALYTICS_BUILDER',
   settings: 'SETTINGS',
   pipelines: 'PIPELINES',
   boards: 'BOARDS',
   templateBoards: 'TEMPLATE_BOARDS',
   recordTemplate: 'RECORD_TEMPLATE',
   leadTemplate: 'LEAD_TEMPLATE',
   uploadPipelineItems: 'UPLOAD_PIPELINE_ITEMS',
   exportLeads: 'EXPORT_LEADS',
   dealTemplate: 'DEAL_TEMPLATE',
   uploadDeals: 'UPLOAD_DEALS',
   exportDeals: 'EXPORT_DEALS',
   activities: 'ACTIVITIES',
   activityTemplates: 'ACTIVITY_TEMPLATES',
   uploadActivities: 'UPLOAD_ACTIVITIES',
   activityLogs: 'ACTIVITY_LOGS',
   taskTemplates: 'TASK_TEMPLATES',
   sharableResources: 'SHARABLE_RESOURCES',
   downloads: 'DOWNLOADS',
   pipelinePermissions: 'PIPELINE_PERMISSIONS',
   leadDistribution: 'LEAD_DISTRIBUTION',
   distributionRules: 'DISTRIBUTION_RULES',
   agentAllocationGroups: 'AGENT_ALLOCATION_GROUPS',
   distributionLogs: 'DISTRIBUTION_LOGS',
   workflows: 'WORKFLOWS',
   allWorkflows: 'ALL_WORKFLOWS',
   workflowLogs: 'WORKFLOW_LOGS',
   relations: 'RELATIONS',
   pipelineEvents: 'PIPELINE_EVENTS',
   documentTemplates: 'DOCUMENT_TEMPLATES',
   scoringConfig: 'SCORING_CONFIG',
   scoringRules: 'SCORING_RULES',
   scoringReCalculationLogs: 'SCORING_RECALCULATION_LOGS',
   dataLoading: 'DATA_LOADING'
}

export const nonExactMatchAdminPipelineNavItemIds = [
   adminPipelinesSectionNavItems.analyticsBuilder
]

export const navActions = {
   add: 'ADD',
   rename: 'RENAME',
   editFIlters: 'EDIT_FILTERS',
   share: 'SHARE',
   delete: 'DELETE'
}

export const SCROLL_DISPLAY_TIME = 300

export const APP_CLIENT_ENUM: ClientType = Config.APP_CLIENT_ENUM
